import { CaretDownIcon, CaretUpIcon } from '@change/ds-icons';

import type { TranslationKey } from '@change-corgi/core/i18n';
import { translationKey } from '@change-corgi/core/i18n';
import type { PersonalizedTasksStatus } from '@change-corgi/middle-end-gql-schema';

import { PERSONALIZED_TASKS_GENERATION_STATUSES } from '../../constants';
import type { DynamicTaskShape, ToggleTaskListData } from '../../types';

export const DEFAULT_TASKS_DISPLAY_COUNT = 3;
export const DYNAMIC_TASKS_EXPANDED_STORAGE_KEY = 'starterDashboardV2_dynamicTasksExpanded';

const VIEW_MORE_WITH_COUNT_LABEL = translationKey('corgi.petition.starter_dashboard_v2.dynamic_tasks.view_more_label');
const VIEW_MORE_PLAIN_LABEL = translationKey('corgi.petition.starter_dashboard_v2.dynamic_tasks.view_more_plain_label');
const VIEW_LESS_LABEL = translationKey('corgi.petition.starter_dashboard_v2.dynamic_tasks.view_less_label');

const TOGGLE_ICONS = [
	<CaretDownIcon className="icon-strong align-middle" size={20} />,
	<CaretUpIcon className="icon-strong align-middle" size={20} />,
] as const;
const NEXT_EXPANDED_VALUES = ['true', null] as const;

function getToggleIndex(expanded: boolean): 0 | 1 {
	return Number(expanded) as 0 | 1;
}

export function getToggleTaskListData(
	allTasks: readonly DynamicTaskShape[],
	expanded: boolean,
	generationStatus: PersonalizedTasksStatus,
): ToggleTaskListData {
	const i = getToggleIndex(expanded);
	const showToggleForGenerationInProgress =
		generationStatus === PERSONALIZED_TASKS_GENERATION_STATUSES.IN_PROGRESS && allTasks.length >= 1;

	const remainingCount = Math.max(0, allTasks.length - DEFAULT_TASKS_DISPLAY_COUNT);

	let toggleTaskListLabel: TranslationKey;
	if (i === 1) {
		toggleTaskListLabel = VIEW_LESS_LABEL;
	} else if (remainingCount > 0) {
		toggleTaskListLabel = VIEW_MORE_WITH_COUNT_LABEL;
	} else {
		toggleTaskListLabel = VIEW_MORE_PLAIN_LABEL;
	}

	return {
		showTaskListToggle: allTasks.length > DEFAULT_TASKS_DISPLAY_COUNT || showToggleForGenerationInProgress,
		toggleTaskListRemainingCount: remainingCount,
		toggleTaskListIcon: TOGGLE_ICONS[i],
		toggleTaskListLabel,
		nextExpandedStorageValue: NEXT_EXPANDED_VALUES[i],
	};
}
